import { Injectable } from "@angular/core";
import { HttpRequest, HttpResponse } from "@angular/common/http";
import { HttpResponseCache } from "./http-response-cache";

@Injectable()
class HttpResponseCacheInMemory implements HttpResponseCache {
  private store = {};
  has(request: HttpRequest<any>) {
    return (
      request.method === "GET" &&
      request.params.get("from_cache") === "true" &&
      !!this.store[request.urlWithParams]
    );
  }
  get(request: HttpRequest<any>) {
    return this.store[request.urlWithParams];
  }
  set(key: HttpRequest<any>["urlWithParams"], value: HttpResponse<any>) {
    this.store[key] = value;
  }
  clear() {
    this.store = {};
  }
}

export const InMemoryCacheProvider = {
  provide: HttpResponseCache,
  useClass: HttpResponseCacheInMemory,
};
